import { OfferPdfList } from './components/OfferPdfList';
import { Route, Routes } from 'react-router-dom';
import { hasAccessRight } from '../../utils/Functions';
import { AdminAclEnum } from '../../enum/AdminAclEnum';

export function OfferPdfRoutes() {
    return (
        <Routes>{hasAccessRight(AdminAclEnum.OFFER_PDFS) && <Route index element={<OfferPdfList />} />}</Routes>
    );
}
